import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { useCreateRoleMutation } from "./rolePermissionApi";

const AddRoleModal = ({ show, setShow, onSuccess }) => {
  const { _t } = useTranslator();

  const ROLE_TYPE_OPTIONS = [
    { value: "administrator", label: _t("administrator", "Administrator") },
    { value: "staff",         label: _t("staff",         "Staff")         },
  ];

  const [formData, setFormData] = useState({ name: "", slug: "", role_type: "staff", working_area_id: "" });
  const [createRole, { isLoading: isCreating }] = useCreateRoleMutation();

  // const { data: workingAreasData } = useGetWorkingAreasQuery({source : "role_and_permission"}, { skip: !show });

  useEffect(() => {
    if (show) setFormData({ name: "", slug: "", role_type: "staff", working_area_id: "" });
  }, [show]);

  useEffect(() => {
    const slug = formData.name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

    if (slug !== formData.slug) {
      setFormData((prev) => ({
        ...prev,
        slug,
      }));
    }
  }, [formData.name]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating) return;
    try {
      await createRole(formData).unwrap();
      onSuccess?.();
      handleClose();
    } catch (err) {
      console.error("Error creating role:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("add_new_role", "Add New Role")}
    >
      <Row>
        <Col lg={12}>
          <InputWithLabel
            label={_t("role_name", "Role Name")}
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={_t("role_name", "Role Name")}
          />
        </Col>
        <Col lg={12}>
          <InputWithLabel
            label={_t("slug", "Slug")}
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            placeholder={_t("role_slug", "Role Slug")}
          />
        </Col>
        <Col lg={12}>
          <SelectBox
            label={_t("role_type", "Role Type")}
            name="role_type"
            value={formData.role_type}
            onChange={handleChange}
            options={ROLE_TYPE_OPTIONS}
          />
        </Col>
        {/* <Col lg={12}>
          <SelectBox
            label={_t("working_area", "Working Area")}
            name="working_area_id"
            value={formData.working_area_id}
            onChange={handleChange}
            options={(workingAreasData?.data || []).map((area) => ({
              value: area.id,
              label: area.name,
            }))}
          />
        </Col> */}
      </Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default AddRoleModal;
